import { capitalize } from '../module'

/** @deprecated - This function is not useful anymore. Currently, only old pages in Predict use this function. Those instances will need to be removed. */
const percentageString = (percent, decimalScale, csvString) => {
  let round = Math.floor(percent * 100) !== 99
  if (percent * 100 >= 1 || percent * 100 === 0) {
    return decimalScale && !round
      ? `${percent * 100}%`
      : `${Math.round(percent * 100)}%`
  } else {
    if (csvString) {
      return `${(percent * 100).toFixed(2)}%`
    } else {
      return '\x3c1%'
    }
  }
}
/** @deprecated - use `aggregateDataValues` instead */
const aggregateDatapoints = (data, propName) => {
  function getSum(total, num) {
    return total + num
  }
  if (data?.length > 0) {
    return data
      ?.map((r) => (propName ? Number(r[propName]) : Number(r)))
      ?.reduce(getSum, 0)
  } else {
    return null
  }
}
/** @deprecated - use `replaceDelimiter` instead */
const replaceSymbol = (text, joinOption, splitSymbol, keepCasing) => {
  let nameFix = text?.split(splitSymbol || '_')
  if (!keepCasing) {
    nameFix = nameFix?.map((e) => {
      e = capitalize(e)
      return e
    })
  }
  return nameFix?.join(joinOption || ' ')
}
const propertyToSort = (property, bool) => {
  if (property[0] === '-') {
    property = property.substr(1)
  }
  return function (a, b) {
    if (a[property] === '—') {
      a[property] = null
    }
    let value1, value2
    if (isNaN(a[property])) {
      value1 = a[property]?.toString()?.toLowerCase()
      value2 = b[property]?.toString()?.toLowerCase()
    } else {
      value1 = Number(a[property])
      value2 = Number(b[property])
    }

    if (a[property] === b[property]) {
      return 0
    } else if (a[property] === null) {
      return 1
    } else if (b[property] === null) {
      return -1
    } else if (bool) {
      return value1 < value2 ? 1 : -1
    } else if (!bool) {
      return value1 < value2 ? -1 : 1
    }
  }
}
/** @deprecated - use `sortByProperty` instead */
const sortFilter = (array, prop, bool) => {
  let filteredState = array.sort(propertyToSort(prop, bool))
  return filteredState
}

export { percentageString, aggregateDatapoints, replaceSymbol, sortFilter }
